function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h4000M0 500h4000M0 1000h4000M0 1500h4000M0 2000h4000M0 0v2000M500 0v2000M1000 0v2000M1500 0v2000M2000 0v2000M2500 0v2000M3000 0v2000M3500 0v2000M4000 0v2000",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 10
});

function SvgHeroGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4000,
    height: 2000,
    opacity: 0.35
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MDAwIiBoZWlnaHQ9IjIwMDAiIG9wYWNpdHk9IjAuMzUiPgogIDxnIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLXdpZHRoPSIxMCI+CiAgICA8cGF0aCBkPSJNMCAwaDQwMDBNMCA1MDBoNDAwME0wIDEwMDBoNDAwME0wIDE1MDBoNDAwME0wIDIwMDBoNDAwME0wIDB2MjAwME01MDAgMHYyMDAwTTEwMDAgMHYyMDAwTTE1MDAgMHYyMDAwTTIwMDAgMHYyMDAwTTI1MDAgMHYyMDAwTTMwMDAgMHYyMDAwTTM1MDAgMHYyMDAwTTQwMDAgMHYyMDAwIi8+CiAgPC9nPgo8L3N2Zz4K";
export { SvgHeroGrid as ReactComponent };